
import React from "react";
import {Button, Col, Container, Row} from "react-bootstrap";
import Select from "react-select";

import {ChartDailyResults} from './strategy/ChartDailyResults';
import {LoadingDisplay} from '../components/LoadingDisplay';
import {IndicatorPerfChartPane} from './indicator/IndicatorPerfChartPane';
import {buildUrl} from '../service/url-builder';

import {withRouter} from "react-router-dom";

const axios = require('axios');

const TIME_KEY = "time"

function ErrorList(params) {
    const errors = params.errors;
    return errors.length > 0 ?  <div>{errors}</div> : "";
}

class ChartFilterForm extends React.Component {

    constructor(props) {
        super(props);

        let queryArgs = new URLSearchParams(this.props.location.search);
        let defaultDate = queryArgs.get('date');
        let defaultConfig = queryArgs.get('config');

        this.state = {
            runContext : this.props.match.params.runContext,
            dateOptions : [],
            configOptions : [],
            formState :{dirty: true, loading: false},
            errorList : [],
            date : defaultDate,
            configName : defaultConfig,
            summaryData : {config: {}},
            data :[],
            orderList:[],
            indicatorPerformanceResults:[]
        }

        this.handleClick = this.handleClick.bind(this);
        this.dateChanged = this.dateChanged.bind(this);
        this.configChanged = this.configChanged.bind(this);

    }

    componentDidMount() {
        this.fetchReferenceData();
        if(this.state.date && this.state.configName){
            this.fetchData();
        }
    }

    handleClick(e) {
        e.preventDefault();
        this.fetchData();
    }

    dateChanged(e) {
        this.setState({
            date:e.value,
            formState: {dirty: true, loading: false}
        });
    }

    configChanged(e) {
        this.setState({
            configName:e.value,
            formState: {dirty: true, loading: false}
        });
    }

    listToLabel(data, row, currentIndex, arr) {
        try {
            data.push(Date.parse(row[TIME_KEY]));
        } catch (error) {
            console.error("error parsing response", error)
        }
    }

    getChartPoint(config, data, row, currentIndex, arr) {
        try {
            for (let rowKey in row) {
                if(data[rowKey] == null){
                    data[rowKey] = [];
                }
                if (rowKey === TIME_KEY) {
                    data[rowKey].push(Date.parse(row[TIME_KEY]));
                } else {
                    data[rowKey].push(row[rowKey])
                }
            }
        } catch (error) {
            console.error("error parsing response", error)
        }
        return data;
    }

    fetchIndicatorPerf(){
        const ordersRequest = axios.get(buildUrl("/indicatorPerformance/dailystats"), {
            params: {
                year: this.state.date.substring(0,4),
                month: this.state.date.substring(4,6),
                day: this.state.date.substring(6,8),
                indicatorConfigName: this.state.configName
            }
        }).then( response => {
            this.setState({"indicatorPerformanceResults": response.data});
        });
    }
    fetchData() {
        this.fetchChartData();
        this.fetchIndicatorPerf();
    }

    fetchChartData() {

        this.setState({
            errors:[],
            formState: {dirty: true, loading: true},
        });

        let date = this.state.date;
        let configName = this.state.configName;
        let runContext = this.state.runContext;

        const configRequest = axios.get(buildUrl("/summaryForDay"), {
            params: {
                runDate: date,
                configName: configName,
                runContext: runContext
            }
        });

        const chartsRequest = axios.get(buildUrl("/chartData"), {
            params: {
                runDate: date,
                configName: configName,
                runContext: runContext
            }
        });

        const ordersRequest = axios.get(buildUrl("/dailyOrders"), {
            params: {
                runDate: date,
                configName: configName,
                runContext: runContext
            }
        });


        axios.all([configRequest, chartsRequest, ordersRequest]).then(axios.spread((...responses) => {
            const configResponse = responses[0];
            const chartResponse = responses[1];
            const ordersResponse = responses[2];
            let tickDate = new Date();

            let parsedChartData = [];
            if(chartResponse.data != null && chartResponse.data.length >0){
                parsedChartData = chartResponse.data.reduce((dataSet, row, index, inputArray) => {
                    tickDate.setTime(Date.parse(row[TIME_KEY]));
                    if(dataSet[tickDate.getHours()] == null){
                        dataSet[tickDate.getHours()] = {}
                    }
                    this.getChartPoint(configResponse.data.config, dataSet[tickDate.getHours()], row, index, inputArray);
                    return dataSet;
                }, {});
            }


            this.setState({
                errors:[],
                formState: {dirty: false, loading: false},
                summaryData:configResponse.data,
                data: parsedChartData,
                orderList: ordersResponse.data
            });

        })).catch( errors => {
            let errMsgs;
            if (Array.isArray(errors)) {
                errMsgs = errors.map(err => {
                    return err.message
                });
            } else {
                errMsgs = [errors.message];
            }
            this.setState({
                errors:errMsgs,
                formState: {dirty: true, loading: false},
            });
        })
    }


    fetchReferenceData() {
        const refDateRequest = axios.get(buildUrl("/referenceData"), {
            params: {
                dataSet: "dates",
                runContext: this.state.runContext
            }
        });

        const refConfigRequest = axios.get(buildUrl("/referenceData"), {
            params: {
                dataSet: "usedConfig",
                runContext: this.state.runContext
            }
        });

        axios.all([refDateRequest, refConfigRequest]).then(axios.spread((...responses) => {
            const dateResponse = responses[0];
            const configNameRespons = responses[1];

            let dateOptions = dateResponse.data.map(option => {
                return {"label": option, "value": option}
            });
            let configOptions = configNameRespons.data.map(option => {
                return {"label": option, "value": option}
            });

            this.setState({
                dateOptions:dateOptions,
                configOptions: configOptions,
            });

        })).catch(errors => {
            console.log("error getting ref data");
        })

    }


    getChartPane(){
        if(this.state.runContext === 'performance'){
            return <IndicatorPerfChartPane data={this.state.data} summaryData={this.state.summaryData} indicatorPerformanceResults={this.state.indicatorPerformanceResults} display={!this.state.formState.dirty} />
        }else{
            return <ChartDailyResults orderList={this.state.orderList} data={this.state.data} summaryData={this.state.summaryData} display={!this.state.formState.dirty} />
        }
    }
render() {
    return (
        <Container>
            <Row>
                <Col>
                    <Select
                        placeholder="Select Configuration"
                        onChange={this.configChanged}
                        value={{"label": this.state.configName, "value":this.state.configName}}
                        options={this.state.configOptions}
                    />
                </Col>
                <Col>
                    <Select
                        placeholder="Select Date"
                        onChange={this.dateChanged}
                        value={{"label": this.state.date, "value":this.state.date}}
                        options={this.state.dateOptions}
                    />
                </Col>
                <Col>
                    <Button onClick={this.handleClick}>
                        Load Data
                    </Button>
                </Col>
            </Row>
            <Row>
                <Col>
                    <ErrorList errors={this.state.errorList}/>
                    <LoadingDisplay loading={this.state.formState.loading}/>
                    {this.getChartPane()}
                </Col>
            </Row>
            <Row>
                <div>  </div>
            </Row>
        </Container>

    );
}
}

const ChartFilterFormWithRouter = withRouter(ChartFilterForm)
export {ChartFilterFormWithRouter}

